<template>
  <div
    ref="login-sidebar"
    class="login-sidebar fixed h-screen z-50 top-0 right-0 bottom-0 left-0 bg-hs-brand-blue"
    :class="{
      'lg:top-auto': !loginOnly,
      'lg:right-auto': !loginOnly,
      'lg:bottom-auto': !loginOnly,
      'lg:left-auto': !loginOnly,
      'respond-lg': !loginOnly,
    }"
  >
    <!-- top -->
    <div
      class="w-full bg-hs-gray"
      :class="{
        'lg:bg-transparent': !loginOnly,
      }"
    >
      <div class="w-80 mx-auto">
        <div
          class="login-sidebar-logo"
          :class="{
            'respond-lg': !loginOnly,}"
        >
          <!-- eslint-disable -->
          <svg width="158" height="77" viewBox="0 0 158 77" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path class="login-sidebar-logo-recolor" :class="{'respond-lg': !loginOnly,}" d="M2.9553e-05 23.817L9.51014 14.3389L14.7668 19.689L5.30556 29.1056L2.9553e-05 23.817Z" />
            <path d="M0.420898 5.10873L5.91253 0L20.1099 14.3289L14.7481 19.689L0.420898 5.10873Z" fill="#F9522C" />
            <path d="M33.2354 29.2786H41.2509V18.1527H51.539V29.2786H59.5546V0H51.539V10.9581H41.2509V0H33.2354V29.2786ZM70.8346 36.0964C75.2969 36.0964 77.4042 34.0052 79.3461 28.735L87.527 6.65054H79.4704L75.2559 20.2859L70.7932 6.65054H62.5713L71.3306 28.8604C70.8346 29.5713 70.2977 29.7806 69.5125 29.7806C68.6449 29.7806 67.3228 29.3209 66.0831 28.5676L63.6452 34.1306C65.7115 35.3016 68.0665 36.0964 70.8346 36.0964ZM90.0888 35.9715H97.9394V26.5183C99.385 28.2329 101.368 29.7806 104.757 29.7806C110.045 29.7806 114.632 25.3048 114.632 17.9434C114.632 10.6238 110.045 6.14847 104.715 6.14847C101.368 6.14847 99.4683 7.77965 97.9394 9.66207V6.65054H90.0888V35.9715ZM102.32 23.1301C99.7981 23.1301 97.7732 20.9968 97.7732 17.9853C97.7732 14.9318 99.7981 12.799 102.32 12.799C104.88 12.799 106.906 14.9318 106.906 17.9014C106.906 21.0383 104.88 23.1301 102.32 23.1301ZM129.093 29.8226C133.555 29.8226 136.654 27.9821 138.802 25.2214L134.464 21.5824C132.853 23.172 131.366 23.8834 129.507 23.8834C127.068 23.8834 125.292 22.628 124.672 20.1609H139.629C139.669 19.6165 139.669 19.031 139.669 18.5293C139.669 11.8788 136.117 6.14847 128.39 6.14847C121.779 6.14847 117.111 11.3767 117.111 17.9853C117.111 25.096 122.069 29.8226 129.093 29.8226ZM124.547 16.1033C124.961 13.6354 126.366 12.0046 128.432 12.0046C130.581 12.0046 132.026 13.5938 132.316 16.1033H124.547ZM143.018 29.2786H150.867V22.2518C150.867 17.0236 153.181 14.6391 157.272 14.6391H157.932V6.27388C154.214 6.10653 152.148 8.11393 150.867 11.2094V6.65054H143.018V29.2786Z" fill="currentColor" />
            <path d="M45.1911 70.1259C50.9272 70.1259 55.0541 66.9079 55.0541 61.9577C55.0541 57.4611 52.0826 55.1099 45.6448 53.707C39.2896 52.3455 37.8035 50.8196 37.8035 48.0968C37.8035 45.4153 40.1966 43.3528 43.9521 43.3528C46.9236 43.3528 49.6063 44.3016 52.2887 46.488L54.187 43.9714C51.257 41.6202 48.2448 40.4236 44.0356 40.4236C38.5459 40.4236 34.5436 43.7651 34.5436 48.3026C34.5436 53.1294 37.5974 55.2748 44.2417 56.7187C50.3081 57.9977 51.7523 59.5236 51.7523 62.2055C51.7523 65.1343 49.1934 67.1967 45.3136 67.1967C41.3105 67.1967 38.4221 65.8353 35.4099 63.1128L33.3882 65.5059C36.8549 68.5992 40.6096 70.1259 45.1911 70.1259ZM68.7138 70.2084C72.7173 70.2084 75.2758 68.4757 77.4213 66.083L75.3174 64.144C73.6251 65.9591 71.6021 67.362 68.8791 67.362C64.4214 67.362 61.0378 63.6904 61.0378 59.0699C61.0378 54.4084 64.3392 50.7368 68.6735 50.7368C71.5615 50.7368 73.542 52.0982 75.2343 53.8723L77.2573 51.727C75.2758 49.6231 72.7584 47.9319 68.7138 47.9319C62.4824 47.9319 57.778 53.0474 57.778 59.0699C57.778 65.1343 62.4824 70.2084 68.7138 70.2084ZM81.4249 69.7128H84.6025V61.2152C84.6025 54.7797 88.3995 51.4382 93.0624 51.4382H93.3101V48.0143C89.2662 47.8494 86.1709 50.407 84.6025 53.9543V48.3855H81.4249V69.7128ZM96.5707 43.7241H100.202V40.2173H96.5707V43.7241ZM96.7768 69.7128H99.9552V48.3855H96.7768V69.7128ZM105.278 76.3137H108.456V65.6294C110.106 68.022 112.665 70.1674 116.627 70.1674C121.786 70.1674 126.821 66.0416 126.821 59.0699C126.821 51.9743 121.744 47.9319 116.627 47.9319C112.707 47.9319 110.188 50.1178 108.456 52.6758V48.3855H105.278V76.3137ZM116.05 67.321C112.088 67.321 108.332 64.0206 108.332 59.0699C108.332 54.1197 112.088 50.7786 116.05 50.7786C120.093 50.7786 123.56 53.9958 123.56 59.0289C123.56 64.2679 120.177 67.321 116.05 67.321ZM137.756 70.0849C139.283 70.0849 140.48 69.7547 141.594 69.1772V66.4543C140.48 66.9904 139.572 67.1967 138.5 67.1967C136.353 67.1967 134.909 66.2479 134.909 63.6494V51.1904H141.678V48.3855H134.909V41.95H131.731V48.3855H128.759V51.1904H131.731V64.0616C131.731 68.3928 134.331 70.0849 137.756 70.0849Z" fill="#9AC8D3" />
          </svg>
          <!-- eslint-enable -->
        </div>
        <form ref="form" class="grid gap-5 px-5 pb-5" @submit.prevent="onSubmit">
          <input
            v-model="form.email"
            placeholder="Email"
            type="email"
            autocomplete="username"
            class="border"
            :class="{ 'lg:border-white': !loginOnly, }"
          >
          <input
            v-model="form.password"
            :placeholder="$t('auth.password')"
            type="password"
            autocomplete="current-password"
            class="border"
            :class="{ 'lg:border-white': !loginOnly, }"
          >
          <div v-if="captchaImg !== null" class="grid gap-5">
            <input
              v-model="form.captcha"
              placeholder="Captcha"
              type="text"
              class="border"
              :class="{ 'lg:border-white': !loginOnly, }"
            >
            <img :src="captchaImg" alt="captcha" class="mx-auto">
          </div>
          <hs-main-button
            class="py-2.5"
            variant="success"
            type="submit"
            :disabled="isWaitingAuth || isDisabled"
          >
            {{ isWaitingAuth ? $t('auth.loggingIn') + '..' : $t('auth.login') }}
          </hs-main-button>
        </form>
        <div
          v-if="errs.length > 0"
          class="text-sm text-center px-5 pb-5 overflow-auto"
          :class="{ 'lg:text-white': !loginOnly, }"
        >
          <span class="font-bold">{{ $t('error') }}:</span><br>
          <!-- eslint-disable-next-line vue/no-v-html-->
          <p v-html="getErrorLabel" />
        </div>
        <div
          class="text-sm text-center px-5 pb-5"
          :class="{ 'lg:text-white': !loginOnly, }"
        >
          <p>{{ $t('auth.needAccount') }}</p>
          <a :href="signUpUrl" target="_blank" class="underline">{{ $t('auth.register') }}</a>
        </div>
      </div>
    </div>
    <!-- /top -->
    <!-- bottom -->
    <div v-if="isFeatureToggled(appFeatures.FEATURE_AUTH_VK) || isFeatureToggled(appFeatures.FEATURE_AUTH_FB)" class="w-full p-6 text-center">
      <p class="text-sm" style="color: #9ac8d3;">
        {{ $t('auth.orLoginVia') }}
      </p>
      <div class="w-14 mx-auto mt-6">
        <div class="px-0 flex justify-between">
          <!--          <hs-social-button-->
          <!--            variant="fb"-->
          <!--            @click="toggleAuthViaFB"-->
          <!--          >-->
          <!--            <icon-base icon-name="facebook">-->
          <!--              <icon-fb />-->
          <!--            </icon-base>-->
          <!--          </hs-social-button>-->
          <hs-social-button
            v-if="isFeatureToggled(appFeatures.FEATURE_AUTH_VK)"
            variant="vk"
            @click="toggleAuthViaVK"
          >
            <icon-base icon-name="vkontakte">
              <icon-vk />
            </icon-base>
          </hs-social-button>
        </div>
        <!-- <hs-social-button
          variant="ok"
        >
          <icon-base icon-name="ok">
            <icon-ok />
          </icon-base>
        </hs-social-button> -->
      </div>
    </div>
    <!-- /bottom -->
    <hyperscript-component-auth
      v-if="isMounted"
      ref="auth"
      :get-user-data-callback="getUserDataCallback"
      :on-login-callback="onLoginCallback"
      :on-logout-callback="onLogoutCallback"
      :on-refresh-token-callback="onRefreshTokenCallback"
      :on-err-callback="onErrCallback"
      :on-give-me-captcha-callback="onGiveMeCaptchaCallback"
      :on-fb-callback="onFbCallback"
      :on-vk-callback="onVkCallback"
    />
  </div>
</template>


<script>
// TODO NPM MODULE
import HyperscriptComponentAuth from '@/core/application/components/auth/hyperscript-component-auth.vue'

// modules
import {
  initSocket,
  closeSocket,
} from '@/core/infrastructure/socket/socket.js'
import {
  eventBus,
} from '@/core/infrastructure/event-bus/event-bus.js'

// ui
import HsMainButton from '@/core/design-system/buttons/hs-main-button.vue'
import HsSocialButton from '@/core/design-system/buttons/hs-social-button.vue'
// import IconFb from '@/components/icon-base/icons/fb.vue'
import IconVk from '@/core/design-system/icon-base/icons/vk.vue'
// import IconOk from '@/components/icon-base/icons/ok.vue'

export default {
  components: {
    HyperscriptComponentAuth,
    HsMainButton,
    HsSocialButton,
    // IconFb,
    IconVk,
    // IconOk,
  },
  props: {
    loginOnly: {
      type: Boolean,
      default: false,
    },
    integrationType: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    form: {
      email: '',
      password: '',
      captcha: '',
    },
    isWaitingAuth: false,
    isMounted: false,
    errs: [],
    savedCallback: null,
    captchaImg: null,
  }),
  computed: {
    userInfo() {
      return this.$store.getters.auth.userInfo || {}
    },
    isDisabled() {
      const { email, password } = this.form
      return email.length === 0 || password.length === 0
    },
    getErrorLabel() {
      if (this.errs[0]?.details?.global) {
        return this.errs[0].details.global
      }
      if (this.errs.length !== 0 && this.captchaImg !== null) {
        return this.$t('auth.errors.captcha')
      }
      console.log('🐹 this', this.errs[0].response)
      return this.$t('auth.errors.somethingWentWrong')
    },
    signUpUrl() {
      const url = new URL(process.env.VUE_APP_SIGNUP_URL)

      if(this.integrationType)
        url.searchParams.append('utm_source', this.integrationType)

      return url.toString()
    },
  },
  watch: {
    form: {
      handler() {
        this.errs = []
      },
      deep: true,
    },
  },
  created() {
    eventBus.on('refreshToken', (callback = null) => {
      if (callback) {
        this.savedCallback = callback
      }
      this.refreshToken()
    })
    eventBus.on('toggleLogout', () => {
      this.toggleLogout()
    })

    eventBus.on('on-callback', obj => {
      console.log('🐹 interceptorCallback.$on(\'on-callback\')', obj)
      const callbackKey = obj.callback

      const cases = {
        logout: () => {
          this.toggleLogout()
        },
        refreshToken: () => {
          this.refreshToken()
        },
        paymentRequired: () => {
          this.$store.dispatch('app/SET_IS_WAITING_CURRENT_SCRIPT_STATUS', false, {root: true})
          this.$router.push({name: this.integrationType + 'Scripts'})
          this.$notify.error({
            title: this.$t('scripts.errors.paymentRequired.title'),
            message: this.$t('scripts.errors.paymentRequired.text'),
            dangerouslyUseHTMLString: true,
            duration: 3000,
          })
        },
        exitInScript: () => {
          this.$store.dispatch('app/SET_IS_WAITING_CURRENT_SCRIPT_STATUS', false, {root: true})
          this.$router.push({name: this.integrationType + 'Scripts'})
        },
        offline: () => {
          this.$store.dispatch('app/SET_IS_WAITING_CURRENT_SCRIPT_STATUS', false, { root: true })
          eventBus.emit('set-online-status', false)
        },
      }
      cases[callbackKey]()
    })
  },
  mounted() {
    this.isMounted = true
    this.clearForm()
  },
  methods: {
    /**
     * onSubmit()
     */
    onSubmit() {
      this.errs = []
      this.isWaitingAuth = true
      this.$refs.auth.onLogin(this.form)
    },

    /**
     * onLoginCallback() - callback after a successful authentication
     */
    onLoginCallback() {
      this.$store.dispatch('app/TOGGLE_LOGIN_SIDEBAR', false)
      this.clearForm()
      setTimeout(() => {
        this.$refs.auth.getUserData()
      }, 1000)
    },

    /**
     * getUserDataCallback() - callback for an SSO event 'getUserData'
     * @param {Object} data - user data
     */
    getUserDataCallback(data) {
      // console.log('🐹 getUserDataCallback', data)
      if (data.token) {
        this.$store.dispatch('auth/AUTHORIZATION', { data: data.data, token: data.token })
        this.$nextTick(() => {
          this.$store.dispatch('app/TOGGLE_LOGIN_SIDEBAR', false)
          if (data.data.id) {
            if (this.$route.name === this.integrationType + 'Pass') {
              this.$store.dispatch('cache/GET_CURRENT_SCRIPT', { vm: this, id: this.$route.params.id })
            } else {
              this.$store.dispatch('cache/GET_SCRIPTS')
              this.$store.dispatch('starredScripts/GET_STARRED_SCRIPTS')
            }
            initSocket(this.userInfo.id, this)
          }
          // TODO: replace inherits
          this.$parent.$parent.hidePreloader()
        })
        // waiting animation
        setTimeout(() => {
          this.isWaitingAuth = false
        }, 500)
      } else {
        this.$store.dispatch('app/TOGGLE_LOGIN_SIDEBAR', true)
        this.$parent.$parent.hidePreloader()
        this.isWaitingAuth = false
      }
    },

    /**
     * refreshToken()
     */
    refreshToken() {
      this.$refs.auth.onRefreshToken()
    },
    async onRefreshTokenCallback() {
     const { name } = window.last_action_link
      console.log('🐹 window.last_action_link', name)
      if (name) {
        this.savedCallback = window.last_action_link
      }
      console.log('🐹 onRefreshTokenCallback - SUCCESS || savedCallback:', this.savedCallback)
      if (Object.keys(this.savedCallback).length > 0 && this.savedCallback.name) {
        await this.$store.dispatch(`cache/${this.savedCallback.name}`, { ...this.savedCallback.payload })
      }
      this.savedCallback = null
    },

    /**
     * toggleLogout() - method call from the authorization module
     */
    toggleLogout() {
      this.$parent.$parent.toggleLogoutPreloader(true)
      this.$refs.auth.onLogout()
    },
    onLogoutCallback() {
      closeSocket()
      this.$parent.$parent.toggleLogoutPreloader(false)
      this.$store.dispatch('app/SET_IS_WAITING_STATUS', true)
      this.$store.dispatch('scripts/CLEAR_SCRIPTS')
      this.$store.dispatch('auth/KILL_CURRENT_USER')
      if (this.$route.name !== this.integrationType + 'Scripts') {
        this.$router.push({ name: this.integrationType + 'Scripts' })
      }
    },

    /**
     * onErrCallback
     */
    onErrCallback(err) {
      console.log('🐹 onErrCallback', err)
      this.errs.push(err)
      this.isWaitingAuth = false
    },

    /**
     * socketCallbacks() - processing socket events in the vue
     */
    socketCallbacks(socketEvent) {
      const { data } = socketEvent
      const event = JSON.parse(data)
      // console.log('🐹 socketCallbacks', typeof event, event)

      switch(event.type) {
        case 'created':
          return this.$store.dispatch('cache/CREATED_SCRIPT', { id: event.script, name: event.script_name, updated: Date.now() })
        case 'updated':
          return this.$store.dispatch('cache/UPDATE_SCRIPT', { id: event.script, name: event.script_name, vm: this })
        case 'removed':
          return this.$store.dispatch('cache/REMOVE_SCRIPT', { id: event.script })
        default:
          return
      }
    },

    onGiveMeCaptchaCallback(base64) {
      this.captchaImg = base64
    },

    clearForm() {
      this.$refs.form.reset()
      this.captchaImg = null
    },

    toggleAuthViaFB() {
      this.$refs.auth.onLoginViaFB()
    },
    onFbCallback(event) {
      if (event.status === true || event.data === true) {
        // this.$refs.auth.getUserData() - doesn't work when re-logging in via social networks
        window.location.reload()
      }
    },

    toggleAuthViaVK() {
      this.$refs.auth.onLoginViaVK()
    },
    onVkCallback(event) {
      if (event.status === true) {
        // this.$refs.auth.getUserData() - doesn't work when re-logging in via social networks
        window.location.reload()
      }
    },
  },
}
</script>
